<template>
  <div class="qmyx-container list">
    <div class="list-item sep input">
      <img
        src="https://assets.rurushishi.com/yq-rs-make/huafa/img/personnel.png"
        class="icon"
      />
      <input
        v-model="name"
        type="text"
        class="flex1 stretch "
        placeholder="请输入姓名"
        :disabled="isFilled"
      />
    </div>
    <div class="list-item sep">
      <img
        src="https://assets.rurushishi.com/yq-rs-make/huafa/img/cert.png"
        class="icon"
      />
      <div class="flex1 stretch input">
        <select-input
          v-model="cert"
          :drop-data="certs"
          placeholder="请选择证件类型"
          @change="handleCertChange"
          :disabled="isFilled"
        />
      </div>
    </div>
    <div class="list-item sep input">
      <div class="icon" />
      <!-- 身份证号码 可支持输入英文字母，因此删除 type=number -->
      <input
        v-model="certNo"
        placeholder="请输入证件号"
        class="flex1 stretch"
        :disabled="isFilled"
      />
    </div>
    <button class="submit-btn btn" @click="handleSubmit" v-if="!isFilled">
      提 交
    </button>
    <div class="tip">
      <div>温馨提示</div>
      <div>个人信息认证后无法修改，请核实后再提交。</div>
    </div>
    <div class="mask" id="success" v-if="showToast">
      <div class="body">
        <h1 class="title">认证成功</h1>
        <p class="txt">您已认证成功，是否变更经纪人身份？</p>

        <div class="btn-group">
          <div class="back" @click="back">返回</div>
          <div class="next text-warning" @click="toChangeStatus">下一步</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import { getCertData, postCertData } from "./api";
import { getAgent } from "../api";
import SelectInput from "../components/select-input";
export default {
  name: "Certification",
  components: {
    SelectInput
  },
  data() {
    return {
      cert: { id: "", text: "" },
      certs: [],
      certNo: "",
      name: "",
      showToast: false,
      isFilled: true
    };
  },
  activated() {
    this.showToast = false;
    this.getAgent();
  },
  methods: {
    async getAgent() {
      const data = await getAgent();
      console.log("agent data", data);
      const info = (data && data.agentLogin) || {};
      this.name = info.agentName;
      this.certNo = info.idNumber;
      this.cert.id = info.certType;
      this.cert.text = info.certTypeD;
      if (info.idNumber) {
        this.isFilled = true;
      } else {
        this.isFilled = false;
        this.getCertData();
      }
    },
    async getCertData() {
      const data = await getCertData();
      console.log("getCertData data", data);
      this.certs = ((data && data.result) || []).map(item => ({
        id: item.serialNumber,
        text: item.name
      }));
      console.log("this.certs", this.certs);
    },
    handleCertChange(cert) {
      this.cert = cert;
      console.log("zheng", this.cert);
    },
    handleSubmit() {
      if (!this.name) {
        return Toast("姓名不能为空");
      } else {
        if (!this.certNo) {
          Toast("身份证号码不能为空");
        } else {
          if (this.cert.id == "102002") {
            //港澳台身份证
            const taiwanreg = /^[A-Z][0-9]{9}$/;
            const xianggangreg = /^[A-Z][0-9]{6}\([0-9A]\)$/;
            const aomenreg = /^[157][0-9]{6}\([0-9]\)$/;
            if (
              taiwanreg.test(this.certNo) ||
              xianggangreg.test(this.certNo) ||
              aomenreg.test(this.certNo)
            ) {
              this.postCert();
            } else {
              Toast("请输入正确的港澳台身份证号码");
            }
          } else if (this.cert.id == "102001") {
            //身份证
            const userCardreg = /(^\d{17}(\d|X|x)$)/;
            if (userCardreg.test(this.certNo)) {
              this.postCert();
            } else {
              Toast("请输入正确的身份证号码");
            }
          }
        }
      }
    },
    async postCert() {
      //agentName:姓名，idNumber：证件号，certType：证件类型编码
      let params = {
        agentName: this.name,
        idNumber: this.certNo,
        certType: this.cert.id
      };
      const data = await postCertData(params);
      this.showToast = data.code === 0;
      if (data.code != 0) {
        Toast(data.msg || "认证失败！");
      }
    },
    toChangeStatus() {
      this.$router.push("/qmyx/agent2");
    },
    back() {
      this.$router.push("/qmyx/client-backup");
    }
  }
};
</script>

<style lang="scss" scoped>
.submit-btn {
  margin-top: 0.8rem;
}
.tip {
  font-size: 0.26rem;
  color: #999999;
  margin-top: 0.8rem;
  line-height: 1.5;
}
.input {
  input {
    &:disabled {
      background: #fff;
      opacity: 1;
      box-shadow: 0 0.02rem 0 0 #efefef;
      border-radius: 0.02rem;
    }
    &::after {
      background: transparent;
    }
  }
  .select-input {
    &::after {
      display: none;
      background: transparent;
    }
  }
}
.mask {
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  .body {
    width: 5.4rem;
    border-radius: 0.2rem;
    background-color: white;
    .title {
      font-size: 0.34rem;
      color: #030303;
      font-weight: bolder;
      text-align: center;
      padding-top: 0.5rem;
      margin-bottom: 0.2rem;
    }
    .txt {
      font-size: 0.28rem;
      color: #4a4a4a;
      text-align: center;
      margin-bottom: 0.3rem;
      padding: 0.12rem;
      line-height: 0.4rem;
    }
  }
  .btn-group {
    border-top: 0.02rem solid #eee;
    text-align: center;
    line-height: 0.8rem;
  }
  .back:first-child {
    border-right: 0.02rem solid #eee;
    width: 50%;
    float: left;
  }

  .tip-btn {
    color: #474747;
    width: 50%;
    color: #9b9b9b;
    height: 0.88rem;
    line-height: 0.88rem;
    text-align: center;
    float: left;
  }
  .text-warning {
    color: #f07b24;
  }
}
</style>
